import { Artworks, Artists, Search, Events } from "@/state.js";
import Artwork from '@/components/Artwork.vue';
import Artist from '@/components/Artist.vue';
import Modal from '@/components/Modal.vue';
import Range from '@/components/Range.vue';
import Event from '@/components/Event.vue';
import Loading from '@/components/Loading.vue';
import { encode as encodeIds, decode as decodeIds } from "@/helpers/encodeIds";

import { pageview } from 'vue-gtag'
import { nextTick } from 'vue'

let lastRouteViewed = {}
let pageViewTimeout
async function trackPageView () {
    await nextTick()

    const page_path = location.pathname
    const page_title = document.title

    if (lastRouteViewed.page_path === page_path && lastRouteViewed.page_title === page_title) return
    lastRouteViewed = {page_path, page_title}

    clearTimeout(pageViewTimeout)
    pageViewTimeout = setTimeout(() => pageview(lastRouteViewed), 300)
}

export default {
    components: {
        Artwork, Artist, Modal, Range, Event, Loading
    },
    watch: {
        searches: {
            handler(/*newValue*/) {
                const vm = this;
                vm.artworksLimit = 24;
            },
            deep: true
        },
        documentTitle: {
            handler(newValue) {
                document.title = newValue
                trackPageView()
            },
            immediate: true
        },
        ogTitle: {
            handler(newValue) {
                document.querySelector('meta[property="og:title"]').content = newValue
            },
            immediate: true
        },
        ogImage: {
            handler(newValue) {
                // todo

                // [x] newsletter signup - on home and events pages
                // [x] contact page

                // [x] share button - show animation/"link copied"
                // [x] keyword search - search tags
                //  [x]  untested / push mam changes
                // [x] add sculpture link
                // [x] recent order by nid
                // [x] artists page = sort alphabetical - remove sort
                // [x] try sidebar sticky at the top
                // [x] hide medium if mentioned in price
                // [x] homepage top image slideshow
                // [x] click outside of modal = close modal
                // [] long term - "now showing" text wysiwyg for homepage
                // [] long term - color hex picker for home callout bg image
                // [x] [start] | [sold] legend on artist page
                // [x] - also "click images to for more info"
                // [x] sidebar instagram icon - https://www.instagram.com/modern.arts.midtown/
                // [x] -upcoming- past events

                // [x] slideshow on events page
                // [x] sort by artist options on favorites/search page
                // [x] undo sold work push to the bottom
                // [x] change 'events' to 'now showing' on sidebar
                // [x] 'click images to for more info' typo

                // [] fix up after view more collapsing image
                // Tom Rierden and Sunny Gibbons: Left and Right of Center

                


                // todo
                const origin = window.origin; //'https://modernartsmidtown.com'; // window.origin
                document.querySelector('meta[property="og:image"]').content = `${origin}${newValue}`;
            },
            immediate: true
        },
        '$route.path': {
            handler: function (newValue) {
                const origin = window.origin; //'https://modernartsmidtown.com'; // window.origin
                document.querySelector('meta[property="og:url"]').content = `${origin}${newValue}`;
                trackPageView()
                // trackPageView(newValue, this)
            },
            //deep: true,
            immediate: true
        }
    },
    mounted() {
        const vm = this;
        vm._onScrollListener = () => {
            const allowance = 300;
            let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight >= document.documentElement.offsetHeight - allowance;
            if (bottomOfWindow && vm.artworksLimit < vm.artworksCount) {
                vm.artworksLimit = vm.artworksLimit + 12;

                //console.log('bottom', vm.artworksLimit);
            }
        };
        window.addEventListener('scroll', vm._onScrollListener);
    },
    unmounted() {
        const vm = this;
        window.removeEventListener('scroll', vm._onScrollListener);
    },
    data() {
        return {
            allEvents: Events,
            allArtists: Artists,
            allArtworks: Artworks,
            artworksLimit: 24,
            searches: {
                heightRange: [0, 1000],
                widthRange: [0, 1000],
                priceRange: [0, 1000000],
                sortBy: "",
                artist: [],
                keyword: Search
            },
            documentTitleBase: 'Modern Arts Midtown | Contemporary Fine Art Gallery | Omaha Nebraska (NE)'
        }
    },
    computed: {
        ogImage() {
            const img = require('@/assets/logo.png');
            return img;
        },
        ogTitle() {
            const vm = this;
            if (vm.documentTitle == vm.documentTitleBase) return vm.documentTitle;
            return vm.documentTitle.replace(vm.documentTitleBase, 'Modern Arts Midtown');
        },
        documentTitle() {
            return this.documentTitleBase;
        },
        nowShowingEvent() {
            const vm = this;
            const next = [...vm.allEvents].reverse().find(event => {
                const end = event.event_date.slice(-1)[0];
                return Date.parse(end) > Date.now() ? true : false;
            });
            return next ? next : this.allEvents[0];
        },
        upcomingEvents() {
            const vm = this;
            return vm.allEvents.filter(event => {
                if (event == vm.nowShowingEvent) return false;

                const end = event.event_date.slice(-1)[0];
                return Date.parse(end) > Date.now() ? true : false;
            });
        },
        pastEvents() {
            const vm = this;
            return vm.allEvents.filter(event => ![...vm.upcomingEvents, vm.nowShowingEvent].includes(event));
        },
        artworksCount() {
            const vm = this;
            return vm.sortedArtworks.length;
        },
        artworks() {
            const vm = this;
            const filtered = vm.sortedArtworks.slice(0, vm.artworksLimit);
            return filtered;
        },
        artists() {
            const vm = this;
            return vm.allArtists;
        },
        alphabeticalArtists() {
            const vm = this;
            if (! vm.allArtists.length) return [];
            return [...vm.allArtists].sort((a, b) => a.lname.toString().localeCompare(b.lname.toString()));
        },
        // selectedArtwork() {
        //     throw new Error('must override');
        // },
        selectedArtworkIndex() {
            const vm = this;
            return vm.sortedArtworks.indexOf(vm.selectedArtwork);
        },
        previousArtwork() {
            const vm = this;
            if (vm.selectedArtworkIndex > 0) {
                return vm.sortedArtworks[vm.selectedArtworkIndex - 1];
            }
            return null;
        },
        nextArtwork() {
            const vm = this;
            if (vm.selectedArtworkIndex === -1) return;
            return vm.sortedArtworks[vm.selectedArtworkIndex + 1];
        },
        filteredArtworks() {
            return [];
            //throw new Error('Component must override filteredArtworks()');
        },
        sortedArtworks() {
            const vm = this;
            //console.log('sortedArtworks');
            var artworks = vm.filteredArtworks;
            // make a copy ([...artworks]) so we can reference current indexOf artwork
            artworks = [...artworks].sort(function compare(a, b) {
                var av, bv;
                switch (vm.searches.sortBy) {
                    case 'size_asc':
                    case 'size_desc':
                        // ['INCH', null, 'FOOT']
                        av = vm.artworkSquareInch(a);
                        bv = vm.artworkSquareInch(b);
                        break;

                    case 'price_asc':
                    case 'price_desc':
                        av = a.price;
                        bv = b.price;
                        break;

                    case 'recent':
                        av = +a.nid || 0;
                        bv = +b.nid || 0;
                        break;

                    case 'artist':
                        av = vm.alphabeticalArtists.indexOf(a.artist);
                        bv = vm.alphabeticalArtists.indexOf(b.artist);
                        break;

                    default:
                        av = artworks.indexOf(a);
                        bv = artworks.indexOf(b);
                        break;
                }
                switch (vm.searches.sortBy) {
                    case 'size_asc':
                    case 'price_asc':
                        if (av == 0) av = Number.MAX_SAFE_INTEGER;
                        if (bv == 0) bv = Number.MAX_SAFE_INTEGER;
                        break;
                }

                if (av < bv) return -1;
                if (av > bv) return 1;
                return 0;
            });

            switch (vm.searches.sortBy) {
                case 'size_desc':
                case 'price_desc':
                case 'recent':
                    artworks = artworks.reverse();
                    break;
            }

            return artworks;
        },

        isDefaultSearch() {
            const vm = this;
            const hMax = vm.heightRangeMax || 1000;
            const wMax = vm.widthRangeMax || 1000;
            const pMax = vm.priceRangeMax || 1000000;

            const isDefault = vm.searches.heightRange[0] == 0
                && vm.searches.heightRange[1] >= hMax
                && vm.searches.widthRange[0] == 0
                && vm.searches.widthRange[1] >= wMax
                && vm.searches.priceRange[0] == 0
                && vm.searches.priceRange[1] >= pMax
                && vm.searches.sortBy == ""
                && vm.searches.artist.length == 0
                && Search.value == "";

            return isDefault;
        },
    },
    methods: {
        // artworkSlug(artwork) {
        //     return `${artwork.title} | ${artwork.nid}`;
        // },
        artworkSlugToId(slug) {
            return slug ? parseInt(slug.split('|').pop()) : null;
        },
        navigate(routerParams) {
            const vm = this;
            vm.$router.push(routerParams)
        },
        artworkSquareInch(artwork) {
            const vm = this;
            return vm.artworkHeightInch(artwork) * vm.artworkWidthInch(artwork);
        },
        artworkHeightInch(artwork) {
            if (typeof artwork._artworkHeightInch == 'undefined') {
                var h = +artwork.height || 0;
                artwork._artworkHeightInch = (artwork.units == 'FOOT') ? h * 12 : h;
            }
            return artwork._artworkHeightInch;
        },
        artworkWidthInch(artwork) {
            if (typeof artwork._artworkWidthInch == 'undefined') {
                var w = +artwork.width || 0;
                artwork._artworkWidthInch = (artwork.units == 'FOOT') ? w * 12 : w;
            }
            return artwork._artworkWidthInch;
        },
        artworkPrice(artwork) {
            return artwork.price;
        },
        clearSearch() {
            const vm = this;
            if (vm.isDefaultSearch) return;

            const hMax = vm.heightRangeMax || 1000;
            const wMax = vm.widthRangeMax || 1000;
            const pMax = vm.priceRangeMax || 1000000;
            vm.searches.heightRange = [0, hMax];
            vm.searches.widthRange = [0, wMax];
            vm.searches.priceRange = [0, pMax];
            vm.searches.sortBy = "";
            vm.searches.artist = [];
            Search.value = "";

            vm.navigate('/search');
            // vm.searches = {
            //     heightRange: [0, 1000],
            //     widthRange: [0, 1000],
            //     priceRange: [0, 1000000],
            //     sortBy: "",
            //     keyword: Search
            // }
        },
        decodeFavorites(encoded) {
            return decodeIds(encoded).map(n => n.toString());
        },
        favoritesPermaLink(favoritesNids) {
            const vm = this;
//            const uri = vm.$router.resolve({name: 'favorites', query: {fav: favoritesNids.join(',')}}).fullPath;
            const uri = vm.$router.resolve({name: 'favorites', query: {fav: encodeIds(favoritesNids)}}).fullPath;
            return `${window.location.origin}${uri}`;
        },
    }
}